import { useMemo } from 'react';
import { Button, Slider } from 'antd';
import { FilterDropdownProps } from 'antd/es/table/interface';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './ColumnSliderFilter.module.scss';

type ColumnSliderFilterProps = Pick<
  FilterDropdownProps,
  'setSelectedKeys' | 'confirm' | 'clearFilters' | 'selectedKeys'
> & {
  marks: Record<string, string>;
};

export const ColumnSliderFilter = ({
  marks,
  setSelectedKeys,
  confirm,
  clearFilters,
  selectedKeys,
}: ColumnSliderFilterProps): React.ReactElement => {
  const { t } = useTranslation('Timesheet');

  const keys = Object.keys(marks).map(Number);
  const minValue = Math.min(...keys);
  const maxValue = Math.max(...keys);

  const sliderValue = useMemo<[number, number]>(() => {
    if (selectedKeys && selectedKeys.length === 2) {
      return [Number(selectedKeys[0]), Number(selectedKeys[1])];
    }
    return [minValue, maxValue];
  }, [selectedKeys, minValue, maxValue]);

  const handleSliderChange = (val: number[]): void => {
    setSelectedKeys(val.map(String));
  };

  const handleReset = (): void => {
    setSelectedKeys([]);
    clearFilters?.();
    confirm();
  };

  return (
    <div className={styles.container}>
      <Slider
        value={sliderValue}
        range
        marks={marks}
        onChange={handleSliderChange}
        min={minValue}
        max={maxValue}
        classNames={{ root: styles.sliderContainer }}
      />
      <div className={styles.buttonContainer}>
        <Button
          onClick={handleReset}
          type="text"
          variant="outlined"
          size="small"
          className={cn(styles.btn, styles.resetButton)}
        >
          {t('resetBtn.text')}
        </Button>
        <Button type="primary" size="small" onClick={() => confirm()} className={styles.btn}>
          {t('okBtn.text')}
        </Button>
      </div>
    </div>
  );
};
